import { Component, Input, OnInit, inject } from '@angular/core';
import { ApiUrlService, CustomRouter, mobileNavigation, VERSION, View } from '@lib/core';
import { EnvService } from '@lib/env';
import { MobileService, SubscriptionHelper } from '@lib/util';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { EprocFeature } from '@lib/feature-toggle';

@Component({
    selector: 'smart-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false,
})
export class PageHeaderComponent extends SubscriptionHelper implements OnInit {
    private readonly store = inject<Store<any>>(Store);
    private readonly apiUrlService = inject(ApiUrlService);
    private readonly router = inject(CustomRouter);
    readonly mobileService = inject(MobileService);

    @Input() public isLogin;
    @Input() public isDeeplink;

    isExpanded = false;

    public version = VERSION;

    public View = View;
    public view: View;
    public apiUrlInStorage = false;

    public env = EnvService;

    public removeApiUrlFromStorage(): void {
        this.apiUrlService.removeApiUrl();
    }

    public async checkIfApiUrlAvailable(): Promise<void> {
        this.apiUrlInStorage = await this.apiUrlService.isApiUrlSetInStorage();
        this.apiUrlService.apiUrlChanged.pipe(takeUntil(this.onDestroy$)).subscribe((apiUrl) => {
            this.apiUrlInStorage = !!apiUrl;
        });
    }

    public openMobileNav($event: MouseEvent): void {
        $event.preventDefault();
        this.store.dispatch(mobileNavigation({ open: true }));
    }

    public async ngOnInit(): Promise<void> {
        await this.checkIfApiUrlAvailable();
        if (!this.isDeeplink) {
            this.view = this.router.getViewFromRoute();
        }
    }

    protected readonly EprocFeature = EprocFeature;
}
